import { handleActions } from 'redux-actions'
import {
  signupSuccess,
  signupError,
  signupStart,
  resetRedirectTo
} from './actions'
import { ERROR_EMAIL_ALREADY_IN_USE, ERROR_UNKNOWN } from './constants'

const defaultState = { user: null, error: null, redirectTo: null }

export default handleActions(
  {
    [signupStart]: state => ({ ...state, pending: true, error: null }),
    [signupSuccess]: state => ({
      ...state,
      redirectTo: '/',
      error: null,
      pending: false
    }),
    [signupError]: (state, { payload: err }) => {
      if (err.code === 'auth/email-already-in-use') {
        return { ...state, pending: false, error: ERROR_EMAIL_ALREADY_IN_USE }
      } else {
        return { ...state, pending: false, error: ERROR_UNKNOWN }
      }
    },
    [resetRedirectTo]: state => ({ ...state, redirectTo: null })
  },
  defaultState
)



// WEBPACK FOOTER //
// ./src/services/signup/reducer.js